import React, { useState, useRef, useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Typography, TextField, Button, Grid, Card, Avatar, FormControl, useMediaQuery, InputLabel, Select, MenuItem, Box } from "@mui/material";
import { api } from "common";
import { useTranslation } from "react-i18next";
import CircularLoading from "components/CircularLoading";
import { makeStyles } from "@mui/styles";
import { MAIN_COLOR, FONT_FAMILY } from "../common/sharedFunctions";
import { useParams,useLocation } from "react-router-dom";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import AlertDialog from "../components/AlertDialog";
import GoBackButton from "components/GoBackButton";
import { C2, C2_FONT } from "../components/Table/C2UserTable";

const useStyles = makeStyles((theme) => ({
    typography: {
        fontFamily: FONT_FAMILY,
      },
    textField: {
        "& label.Mui-focused": {
            color: MAIN_COLOR,
        },
        "& .MuiInput-underline:after": {
            borderBottomColor: MAIN_COLOR,
        },
        "& .MuiFilledInput-underline:after": {
            borderBottomColor: MAIN_COLOR,
        },
        "& .MuiOutlinedInput-root": {
            "&.Mui-focused fieldset": {
                borderColor: MAIN_COLOR,
            },
        },
        "& input": {
            fontFamily: FONT_FAMILY,
          },
    },
    rootRtl: {
        "& label": {
            right: 10,
            left: "auto",
            paddingRight: 20,
            fontFamily: FONT_FAMILY,
        },
        "& legend": {
            textAlign: "right",
            marginRight: 20,
            fontFamily: FONT_FAMILY,
        },
        "& label.Mui-focused": {
            color: MAIN_COLOR,
        },
        "& .MuiInput-underline:after": {
            borderBottomColor: MAIN_COLOR,
        },
        "& .MuiFilledInput-underline:after": {
            borderBottomColor: MAIN_COLOR,
        },
        "& .MuiOutlinedInput-root": {
            "&.Mui-focused fieldset": {
                borderColor: MAIN_COLOR,
            },
        },
        "& input": {
            fontFamily: FONT_FAMILY,
          },
    },
    rootRtl_3: {
        "& label": {
            right: 0,
            left: "auto",
            paddingRight: 20,
            fontFamily: FONT_FAMILY,
        },
        "& legend": {
            textAlign: "right",
            marginRight: 20,
            fontFamily: FONT_FAMILY,
        },
        "& label.Mui-focused": {
            color: MAIN_COLOR,
        },
        "& .MuiInput-underline:after": {
            borderBottomColor: MAIN_COLOR,
        },
        "& .MuiFilledInput-underline:after": {
            borderBottomColor: MAIN_COLOR,
        },
        "& .MuiOutlinedInput-root": {
            "&.Mui-focused fieldset": {
                borderColor: MAIN_COLOR,
            },
        },
        "& input": {
            fontFamily: FONT_FAMILY,
          },
    },
    rootRtl_2: {
        "& label": {
            right: 5,
            left: "auto",
            paddingRight: 20,
            fontFamily: FONT_FAMILY,
        },
        "& legend": {
            textAlign: "right",
            marginRight: 20,
            fontFamily: FONT_FAMILY,
        },
        "& label.Mui-focused": {
            color: MAIN_COLOR,
        },
        "& .MuiInput-underline:after": {
            borderBottomColor: MAIN_COLOR,
        },
        "& .MuiFilledInput-underline:after": {
            borderBottomColor: MAIN_COLOR,
        },
        "& .MuiOutlinedInput-root": {
            "&.Mui-focused fieldset": {
                borderColor: MAIN_COLOR,
            },
        },
        "& input": {
            fontFamily: FONT_FAMILY,
          },
    },
    rootRtl_1: {
        "& label": {
            right: 10,
            left: "auto",
            paddingRight: 20,
            fontFamily: FONT_FAMILY,
        },
        "& legend": {
            textAlign: "right",
            marginRight: 15,
            fontFamily: FONT_FAMILY,
        },
        "& label.Mui-focused": {
            color: MAIN_COLOR,
        },
        "& .MuiInput-underline:after": {
            borderBottomColor: MAIN_COLOR,
        },
        "& .MuiFilledInput-underline:after": {
            borderBottomColor: MAIN_COLOR,
        },
        "& .MuiOutlinedInput-root": {
            "&.Mui-focused fieldset": {
                borderColor: MAIN_COLOR,
            },
        },
        "& input": {
            fontFamily: FONT_FAMILY,
          },
    },

    selectField_rtl: {
        color: "black",
        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: MAIN_COLOR,
        },
        "& label": {
            right: 0,
            left: "auto",
            fontFamily: FONT_FAMILY,

        },
        "& legend": {
            textAlign: "right",
            marginRight: 35,
            fontFamily: FONT_FAMILY,
        },
    },

    right: {
        textAlign: "right", right: 0, left: "auto", paddingRight: 40, fontFamily: FONT_FAMILY,
    },
    right_1: {
        textAlign: "right", right: 0, left: "auto", paddingRight: 45, fontFamily: FONT_FAMILY,
    },


    selectField: {
        color: "black",
        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: MAIN_COLOR,
        },
    },
}));

function EditUser() {
    const { id, usertype } = useParams();
    const { t, i18n } = useTranslation();
    const isRTL = i18n.dir();
    const staticusers = useSelector((state) => state.usersdata.staticusers);
    const settings = useSelector((state) => state.settingsdata.settings);
    const auth = useSelector((state) => state.auth);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const loaded = useRef(false);
    const fileInputRef = useRef();
    const {
        editUser,
        fetchUsersOnce,
        updateCustomerProfileImage,
        checkUserExists,
        addUser,
        fetchZonificacionCities,
        CUSTOMER_CITIES,
        customerCityLabel,
        findCustomerCity,
    } = api;
    const [commonAlert, setCommonAlert] = useState({ open: false, msg: "" });
    const [data, setData] = useState(null);
    const [oldData, setOldData] = useState(null);
    const [profileImage, setProfileImage] = useState(null);
    const [loading, setLoading] = useState(false);
    const classes = useStyles();
    const [fleetAdmins, setFleetAdmins] = useState([]);
    const [fleetAdminsObj, setFleetAdminsObj] = useState("");
    const [approved, setApproved] = useState(false);
    const isMidScreen = useMediaQuery('(max-width:1199px)');
    const [signUpReferraldata,setsignupReferralData]= useState("")
    const {state}=useLocation()
    const zonificacionCities = useSelector((state) => state.zonificacion?.cities);
    const needsCity = usertype === "customer" || usertype === "driver";
    const isCustomerUser = usertype === "customer";
    const driverCities = useMemo(
        () => (zonificacionCities || []).filter((c) => c.active !== false),
        [zonificacionCities]
    );
    const customerCities = useMemo(
        () => (Array.isArray(CUSTOMER_CITIES) ? CUSTOMER_CITIES : []),
        [CUSTOMER_CITIES]
    );
    const citiesForRole = useMemo(() => {
        const base = isCustomerUser ? customerCities : driverCities;
        // Conservar ciudad actual si no está en la lista (datos legacy / edición)
        if (data?.cityId && !base.some((c) => c.id === data.cityId)) {
            return [
                {
                    id: data.cityId,
                    name: data.cityName || data.cityId,
                    department: "",
                },
                ...base,
            ];
        }
        return base;
    }, [isCustomerUser, customerCities, driverCities, data?.cityId, data?.cityName]);

    useEffect(() => {
        dispatch(fetchUsersOnce());
    }, [dispatch, fetchUsersOnce]);

    useEffect(() => {
        if (usertype === "driver" && typeof fetchZonificacionCities === "function") {
            dispatch(fetchZonificacionCities());
        }
    }, [dispatch, fetchZonificacionCities, usertype]);

    const validateCitySelection = () => {
        if (!needsCity) return true;
        if (!data?.cityId) {
            setCommonAlert({
                open: true,
                msg: t("signup_err_city_required") || "Selecciona una ciudad.",
            });
            return false;
        }
        if (isCustomerUser) {
            const listed = findCustomerCity
                ? findCustomerCity(data.cityId)
                : customerCities.find((c) => c.id === data.cityId);
            // Alta: debe estar en la lista. Edición legacy: permitir cityId+cityName existentes.
            if (!listed && !(id && data.cityId && data.cityName)) {
                setCommonAlert({
                    open: true,
                    msg: t("signup_err_city_required") || "Selecciona una ciudad válida.",
                });
                return false;
            }
            return true;
        }
        const city = driverCities.find((c) => c.id === data.cityId);
        if (!city && !(data.cityId && data.cityName)) {
            setCommonAlert({
                open: true,
                msg: t("signup_err_city_inactive") || "La ciudad seleccionada no está activa.",
            });
            return false;
        }
        return true;
    };

    useEffect(() => {
        if (id && usertype) {
            if (staticusers) {
                const user = staticusers.filter(
                    (user) => user.id === id.toString() && user.usertype === usertype.toString()
                )[0];
                const refferedUser = staticusers.filter(
                    (value) =>value.id === user?.signupViaReferral
                )
                if(refferedUser.length>0){
                    const refferedData= `${refferedUser[0].firstName} ${refferedUser[0].lastName} (${refferedUser[0].mobile} ) ${refferedUser[0].email}` 
                    setsignupReferralData(refferedData)
                }
                if (!user) {
                    navigate("/404");
                }
                setData(user);
                setOldData(user);
            }
        } else {
            setData([]);
        }
        loaded.current = true;
    }, [staticusers, id, navigate, usertype]);

    useEffect(() => {
        if (staticusers) {
            if (auth && auth.profile && auth.profile.usertype === "admin") {
                let arr = staticusers.filter((user) => user.usertype === "fleetadmin");
                let obj = {};
                let arr2 = [];
                for (let i = 0; i < arr.length; i++) {
                    let user = arr[i];
                    arr2.push({
                        id: user.id,
                        desc:
                            user.firstName +
                            " " +
                            user.lastName +
                            " (" +
                            (settings.AllowCriticalEditsAdmin
                                ? user.mobile
                                : t("hidden_demo")) +
                            ") " +
                            (settings.AllowCriticalEditsAdmin
                                ? user.email
                                : t("hidden_demo")),
                    });
                    obj[user.id] =
                        user.firstName +
                        " " +
                        user.lastName +
                        " (" +
                        (settings.AllowCriticalEditsAdmin
                            ? user.mobile
                            : t("hidden_demo")) +
                        ") " +
                        (settings.AllowCriticalEditsAdmin ? user.email : t("hidden_demo"));
                }
                setFleetAdmins(arr2);
                setFleetAdminsObj(obj);
            }
        }
    }, [
        staticusers,
        auth.profile.usertype,
        auth.profile.uid,
        settings.AllowCriticalEditsAdmin,
        auth,
        t
    ]);

    const profileImageChange = async (e) => {
        setProfileImage(e.target.files[0]);
    };

    const handleCommonAlertClose = (e) => {
        e.preventDefault();
        setCommonAlert({ open: false, msg: "" });
    };

    const handleInputChange = (e) => {
        setData({ ...data, [e.target.id]: e.target.value });
    };

    const handleChangeApproved = (event) => {
        setApproved(event.target.value);
        setData({ ...data, approved: event.target.value });
    };

    const getKeyByValue = (object, value) => {
        return Object.keys(object).find((key) => object[key] === value);
    };

    const handleChangeFleetAdmin = (event) => {
        setData({
            ...data,
            fleetadmin: getKeyByValue(fleetAdminsObj, event.target.value),
        });
    };
    const navigateToInfo = () => {
        setTimeout(() => {
            setProfileImage(null);
            if (usertype === "customer") {
                navigate("/users/0",{state:{pageNo:state?.pageNo}});
            } else if (usertype === "driver") {
                navigate("/users/1",{state:{pageNo:state?.pageNo}});
            } else if (usertype === "fleetadmin") {
                navigate("/users/3",{state:{pageNo:state?.pageNo}});
            } else if (usertype === "admin") {
                navigate("/users/4",{state:{pageNo:state?.pageNo}});
            }
            setLoading(false);
        }, 1000);
    }
    const handleUpdate = () => {
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (!(data.lastName && data.firstName)) {
            setCommonAlert({ open: true, msg: t("proper_input_name") });
        } else if (!re.test(data.email)) {
            setCommonAlert({ open: true, msg: t("proper_email") });
        } else if (!data.mobile) {
            setCommonAlert({ open: true, msg: t("proper_mobile") });
        } else if (!validateCitySelection()) {
            return;
        } else {
            if (settings.AllowCriticalEditsAdmin) {
                setLoading(true);

                if (profileImage) {
                    updateCustomerProfileImage(profileImage, data.id).then(() => {
                        dispatch(fetchUsersOnce());
                        navigateToInfo()
                    });
                }
                if (
                    JSON.stringify(oldData) !== JSON.stringify(data) &&
                    Object.keys(data).length !== 0
                ) {
                    const payload = { ...data };
                    if (needsCity && payload.cityId) {
                        const city = citiesForRole.find((c) => c.id === payload.cityId);
                        if (city) payload.cityName = city.name || payload.cityName || "";
                    }
                    dispatch(editUser(data.id, payload));
                    dispatch(fetchUsersOnce());
                    navigateToInfo()
                }
                if (
                    JSON.stringify(oldData) === JSON.stringify(data) && !profileImage 
                ) {
                    setCommonAlert({ open: true, msg: t("make_changes_to_update") });
                    setLoading(false);
                }

            }else {
                setCommonAlert({ open: true, msg: t('demo_mode') });
            }
            loaded.current = true;
        }
    };


    const handleAdd = () => {
        const re =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        if (!(data.lastName && data.firstName)) {
            setCommonAlert({ open: true, msg: t("proper_input_name") });
        } else if (!re.test(data.email)) {
            setCommonAlert({ open: true, msg: t("proper_email") });
        } else if (!data.mobile) {
            setCommonAlert({ open: true, msg: t("proper_mobile") });
        } else if (!validateCitySelection()) {
            return;
        } else {
            new Promise((resolve, reject) => {
                setLoading(true);
                setTimeout(() => {
                    checkUserExists(data).then((res) => {
                        if (res.users && res.users.length > 0) {
                            setCommonAlert({ open: true, msg: t("user_exists") });
                            reject(new Error("User already exists"));
                        } else if (res.error) {
                            setCommonAlert({ open: true, msg: t("email_or_mobile_issue") });
                            reject(new Error("Email or Mobile issue"));
                        } else {
                            const c = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
                            const reference = [...Array(5)]
                                .map((_) => c[~~(Math.random() * c.length)])
                                .join("");
                            data["createdAt"] = new Date().getTime();
                            let role = auth.profile.usertype;
                            data['approved'] = approved;
                            data['walletBalance'] = 0;
                            if (needsCity) {
                                const city = citiesForRole.find((c) => c.id === data.cityId);
                                data["cityId"] = data.cityId;
                                data["cityName"] = city?.name || data.cityName || "";
                            }
                            if(usertype === "customer"){
                                data["usertype"] = "customer";
                                data["referralId"] = reference;
                                if (role === "fleetadmin") {
                                    data["fleetadmin"] = auth.profile.uid;
                                }
                                resolve();
                            }else if(usertype === "driver"){
                                data["driverActiveStatus"] = false;
                                data["usertype"] = "driver";
                                data["referralId"] = reference;
                                data["queue"] = false;
                                if (role === "fleetadmin") {
                                    data["fleetadmin"] = auth.profile.uid;
                                }
                                if(approved === true){
                                    data['adminApprovedTrue'] = true;
                                }else{
                                    data['adminApprovedTrue'] = false;
                                }
                                resolve();
                            }else if(usertype === "fleetadmin") {
                                data["usertype"] = "fleetadmin";
                                data["createdAt"] = new Date().getTime();
                                resolve();
                            }else if(usertype === "admin"){
                                data["usertype"] = usertype.toString();
                                data["createdAt"] = new Date().getTime();
                                data["approved"] = true;
                                resolve();
                            }else{
                                reject(new Error("Invalid usertype Add"));
                                setCommonAlert({ open: true, msg: t("invalid_userType_add") });
                            }
                            dispatch(addUser(data));
                            dispatch(fetchUsersOnce());
                            handleBackNavigation()

                        }
                    }, 600);
                });
            }).catch((e) => {
                console.error("caught an error:",e)
            }).finally(() => {
                setLoading(false);
            });
        }
    };

    const handleBackNavigation = ()=>{
        if(usertype === "customer"){
            navigate("/users/0");
        }else if(usertype === "driver"){
            navigate("/users/1");
        }else if (usertype === "fleetadmin"){
            navigate("/users/3");
        }else if(usertype === "admin"){
            navigate("/users/4");
        }
    }

    const isDriverOrFleetAdmin = usertype === "driver" || usertype === "fleetadmin";
    const isNotAdmin = auth.profile.usertype === 'fleetadmin' || auth.profile.usertype === 'driver';

    const pageTitle = id
        ? (
            (usertype === "customer" && t("update_customer_title")) ||
            (usertype === "driver" && t("update_driver_title")) ||
            (usertype === "fleetadmin" && t("update_fleetAdmin_title")) ||
            (usertype === "admin" && t("update_admin_title"))
        )
        : (
            (usertype === "customer" && t("add_customer_title")) ||
            (usertype === "driver" && t("add_driver_title")) ||
            (usertype === "fleetadmin" && t("add_fleetadmin_title")) ||
            (usertype === "admin" && t("add_admin_title"))
        );

    const pageSubtitle =
        usertype === "customer"
            ? "Datos del usuario / cliente"
            : usertype === "driver"
            ? "Datos del conductor"
            : "Datos de la cuenta";

    const fieldSx = {
        "& .MuiOutlinedInput-root": {
            borderRadius: "12px",
            bgcolor: C2.white,
            fontFamily: C2_FONT,
            "& fieldset": { borderColor: C2.border },
            "&:hover fieldset": { borderColor: C2.bright },
            "&.Mui-focused fieldset": { borderColor: C2.violet },
        },
        "& .MuiInputLabel-root": { fontFamily: C2_FONT, color: C2.muted },
        "& .MuiInputLabel-root.Mui-focused": { color: C2.violet },
        "& input": { fontFamily: C2_FONT },
    };

    return loading ? (
        <CircularLoading />
    ) : (
        <Box sx={{ width: "100%", bgcolor: C2.bg, borderRadius: 2, p: { xs: 1.5, md: 2 } }}>
            <Card
                sx={{
                    borderRadius: "20px",
                    bgcolor: C2.white,
                    maxWidth: 1100,
                    mx: "auto",
                    overflow: "hidden",
                    boxShadow: "0 8px 28px rgba(26,15,59,0.08)",
                    border: `1px solid ${C2.border}`,
                }}
            >
                <Box
                    sx={{
                        background: `linear-gradient(135deg, ${C2.deep} 0%, ${C2.violet} 55%, ${C2.bright} 100%)`,
                        px: { xs: 2, md: 3 },
                        pt: 2,
                        pb: 3,
                    }}
                >
                    <GoBackButton isRTL={isRTL} light onClick={navigateToInfo} />
                    <Typography
                        sx={{
                            fontFamily: C2_FONT,
                            fontWeight: 800,
                            fontSize: { xs: 22, md: 26 },
                            color: C2.white,
                            mt: 0.5,
                            textAlign: isRTL === "rtl" ? "right" : "left",
                        }}
                    >
                        {pageTitle}
                    </Typography>
                    <Typography
                        sx={{
                            fontFamily: C2_FONT,
                            fontSize: 13,
                            color: "rgba(251,250,254,0.75)",
                            mt: 0.5,
                            textAlign: isRTL === "rtl" ? "right" : "left",
                        }}
                    >
                        {pageSubtitle}
                    </Typography>
                </Box>

                <Box sx={{ p: { xs: 2, md: 3 }, bgcolor: C2.bg }}>
                <Grid
                    container
                    spacing={3}
                    sx={{ direction: isRTL === "rtl" ? "rtl" : "ltr" }}
                    justifyContent="center"
                    alignItems="flex-start"
                >
                    {id ?
                        <Grid item xs={12} sm={12} md={12} lg={3} xl={3} display="flex" justifyContent="center">
                            <Box sx={{ width: 160, textAlign: "center" }}>
                                {profileImage ? (
                                    <Box
                                        onClick={() => fileInputRef.current.click()}
                                        sx={{ cursor: "pointer", display: "inline-flex" }}
                                    >
                                        <Box
                                            component="img"
                                            src={URL.createObjectURL(profileImage)}
                                            alt="Profile"
                                            sx={{
                                                width: 140,
                                                height: 140,
                                                borderRadius: "50%",
                                                objectFit: "cover",
                                                border: `3px solid ${C2.border}`,
                                                boxShadow: "0 8px 20px rgba(100,17,237,0.15)",
                                            }}
                                        />
                                    </Box>
                                ) : data?.profile_image ? (
                                    <Box
                                        onClick={() => fileInputRef.current.click()}
                                        sx={{ cursor: "pointer", display: "inline-flex" }}
                                    >
                                        <Box
                                            component="img"
                                            src={data.profile_image}
                                            alt="Profile"
                                            sx={{
                                                width: 140,
                                                height: 140,
                                                borderRadius: "50%",
                                                objectFit: "cover",
                                                border: `3px solid ${C2.border}`,
                                                boxShadow: "0 8px 20px rgba(100,17,237,0.15)",
                                            }}
                                        />
                                    </Box>
                                ) : (
                                    <Box
                                        onClick={() => fileInputRef.current.click()}
                                        sx={{ cursor: "pointer", display: "inline-flex" }}
                                    >
                                        <Avatar
                                            sx={{
                                                width: 140,
                                                height: 140,
                                                flexDirection: "column",
                                                border: `2px dashed ${C2.border}`,
                                                bgcolor: C2.lavender,
                                                color: C2.muted,
                                                fontFamily: C2_FONT,
                                                fontSize: 13,
                                                fontWeight: 700,
                                                textAlign: "center",
                                            }}
                                        >
                                            <FileUploadIcon sx={{ fontSize: 40, mb: 0.5, color: C2.violet }} />
                                            {t("upload_profile_image")}
                                        </Avatar>
                                    </Box>
                                )}
                                <Typography
                                    sx={{
                                        mt: 1.5,
                                        fontFamily: C2_FONT,
                                        fontSize: 12,
                                        color: C2.muted,
                                    }}
                                >
                                    Toca para cambiar foto
                                </Typography>
                                <input
                                    onChange={(event) => profileImageChange(event)}
                                    multiple={false}
                                    ref={fileInputRef}
                                    type="file"
                                    hidden
                                    accept="image/*"
                                />
                            </Box>
                        </Grid>
                        : null}
                    <Grid item xs={12} sm={12} md={12} lg={id ? 9 : 12} xl={id ? 9 : 12}>
                        <Grid
                            container
                            spacing={2}
                            sx={{
                                direction: isRTL === "rtl" ? "rtl" : "ltr",
                            }}
                        >
                            <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                                <TextField
                                    InputLabelProps={{ style: { fontFamily: C2_FONT } }}
                                    label={t("firstname")}
                                    id="firstName"
                                    value={data?.firstName || ""}
                                    fullWidth
                                    onChange={handleInputChange}
                                    className={isRTL === "rtl" ? classes.rootRtl_1 : classes.textField}
                                    sx={fieldSx}
                                />
                            </Grid>
                            <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                                <TextField
                                    InputLabelProps={{ style: { fontFamily: C2_FONT } }}
                                    label={t("last_name")}
                                    id="lastName"
                                    value={data?.lastName || ""}
                                    fullWidth
                                    onChange={handleInputChange}
                                    className={isRTL === "rtl" ? classes.rootRtl_1 : classes.textField}
                                    sx={fieldSx}
                                />
                            </Grid>
                            <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                                <TextField
                                    InputLabelProps={{ style: { fontFamily: C2_FONT } }}
                                    label={t("mobile")}
                                    id="mobile"
                                    value={id ? settings.AllowCriticalEditsAdmin ? data?.mobile || "" : t("hidden_demo") : data?.mobile || ""}
                                    fullWidth
                                    disabled={id ? true : false}
                                    onChange={handleInputChange}
                                    className={isRTL === "rtl" ? classes.rootRtl_2 : classes.textField}
                                    sx={fieldSx}
                                />
                            </Grid>
                            <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                                <TextField
                                    InputLabelProps={{ style: { fontFamily: C2_FONT } }}
                                    label={t("email")}
                                    id="email"
                                    value={id ? settings.AllowCriticalEditsAdmin ? data?.email || "" : t("hidden_demo") : data?.email || ""}
                                    fullWidth
                                    disabled={id ? true : false}
                                    onChange={handleInputChange}
                                    className={isRTL === "rtl" ? classes.rootRtl : classes.textField}
                                    sx={fieldSx}
                                />
                            </Grid>
                            <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                                <FormControl fullWidth className={isRTL === "rtl" ? classes.rootRtl : classes.textField} sx={fieldSx}>
                                    <InputLabel id="gender-label" style={{ fontFamily: C2_FONT }}>
                                        {t("gender") || "Género"}
                                    </InputLabel>
                                    <Select
                                        labelId="gender-label"
                                        id="gender"
                                        label={t("gender") || "Género"}
                                        value={data?.gender || ""}
                                        onChange={(e) => setData({ ...data, gender: e.target.value || null })}
                                        sx={{ fontFamily: C2_FONT, borderRadius: "12px" }}
                                    >
                                        <MenuItem value=""><em>{t("select_gender") || "Seleccionar"}</em></MenuItem>
                                        <MenuItem value="female">{t("gender_female") || "Mujer"}</MenuItem>
                                        <MenuItem value="male">{t("gender_male") || "Hombre"}</MenuItem>
                                        <MenuItem value="other">{t("gender_other") || "Otro"}</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                            {needsCity ? (
                                <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                                    <FormControl fullWidth className={isRTL === "rtl" ? classes.rootRtl : classes.textField} sx={fieldSx}>
                                        <InputLabel id="city-label" style={{ fontFamily: C2_FONT }}>
                                            {t("city") || "Ciudad"}
                                        </InputLabel>
                                        <Select
                                            labelId="city-label"
                                            id="cityId"
                                            label={t("city") || "Ciudad"}
                                            value={data?.cityId || ""}
                                            disabled={!isCustomerUser && citiesForRole.length === 0}
                                            onChange={(e) => {
                                                const cityId = e.target.value;
                                                const city = citiesForRole.find((c) => c.id === cityId);
                                                setData({
                                                    ...data,
                                                    cityId: cityId || "",
                                                    cityName: city?.name || "",
                                                });
                                            }}
                                            sx={{ fontFamily: C2_FONT, borderRadius: "12px" }}
                                        >
                                            <MenuItem value="">
                                                <em>
                                                    {!isCustomerUser && citiesForRole.length === 0
                                                        ? t("no_cities_configured") || "Sin ciudades"
                                                        : t("select_city_placeholder") || "Selecciona tu ciudad"}
                                                </em>
                                            </MenuItem>
                                            {citiesForRole
                                                .slice()
                                                .sort((a, b) =>
                                                    String(a.name || "").localeCompare(String(b.name || ""), "es")
                                                )
                                                .map((c) => (
                                                    <MenuItem key={c.id} value={c.id}>
                                                        {customerCityLabel
                                                            ? customerCityLabel(c)
                                                            : c.department
                                                            ? `${c.name} (${c.department})`
                                                            : c.name}
                                                    </MenuItem>
                                                ))}
                                        </Select>
                                    </FormControl>
                                </Grid>
                            ) : null}
                            {usertype !== "admin" ?

                                <>

                                    {usertype !== "fleetadmin" ?
                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={12}
                                            lg={6}
                                            xl={6}
                                            style={{
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                            }}
                                        >
                                            <TextField
                                                InputLabelProps={{ style: { fontFamily: C2_FONT } }}
                                                label={t("verify_id")}
                                                id="verifyId"
                                                value={data?.verifyId || ""}
                                                fullWidth
                                                onChange={handleInputChange}
                                                className={isRTL === "rtl" ? classes.rootRtl_3 : classes.textField}
                                                sx={fieldSx}
                                            />
                                        </Grid>
                                        : null}
                                        {id? 
                                        <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                                        <TextField
                                            label={t("codigo_master")}
                                            id="referralId"
                                            value={data?.referralId ? data?.referralId : t('no_data_available')}
                                            fullWidth
                                            disabled={id ? true : false}
                                            className={isRTL === "rtl" ? classes.rootRtl_1 : classes.textField}
                                            sx={fieldSx}
                                        />
                                        </Grid>
                                        :null}
                                           {id ?
                                           <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                                           <TextField
                                               label={t("signup_via_referral")}
                                               id="signup_via_referral"
                                               value={ settings.AllowCriticalEditsAdmin? signUpReferraldata?signUpReferraldata: t('no_data_available') : t("hidden_demo")}
                                               fullWidth
                                               disabled={id ? true : false}
                                               className={isRTL === "rtl" ? classes.rootRtl_1 : classes.textField}
                                               sx={fieldSx}
                                           />
                                           </Grid>
                                           : null} 
                                    <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                                        <FormControl fullWidth style={{ direction: isRTL === "rtl" ? "rtl" : 'ltr' }} sx={fieldSx}>
                                            <InputLabel id="demo-simple-select-label" className={isRTL === "rtl" ? classes.right : ""} sx={{ "&.Mui-focused": { color: C2.violet }, fontFamily: C2_FONT }}>
                                                {<Typography className={classes.typography}>{t("approve_status")}</Typography>}
                                            </InputLabel>
                                            <Select
                                                labelId="demo-simple-select-label"
                                                id="demo-simple-select"
                                                value={data?.approved ? data.approved : approved}
                                                label={t("approve_status")}
                                                onChange={handleChangeApproved}
                                                className={isRTL === "rtl" ? classes.selectField_rtl : classes.selectField}
                                                sx={{ borderRadius: "12px", fontFamily: C2_FONT }}
                                            >
                                                <MenuItem style={{ direction: isRTL === "rtl" ? "rtl" : "ltr" }} value={true}>
                                                {<Typography className={classes.typography}>{t("approved")}</Typography>}
                                                </MenuItem>
                                                <MenuItem style={{ direction: isRTL === "rtl" ? "rtl" : "ltr" }} value={false}>
                                                {<Typography className={classes.typography}>{t("not_approved")}</Typography>}
                                                </MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    {auth?.profile?.usertype !== "fleetadmin" && usertype === "driver" ? (
                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={12}
                                            lg={6}
                                            xl={6}
                                            style={{
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                            }}
                                        >
                                            <FormControl fullWidth style={{ direction: isRTL === "rtl" ? "rtl" : 'ltr' }}>
                                                <InputLabel id="fleetadmins" className={isRTL === "rtl" ? classes.right_1 : ""} sx={{ "&.Mui-focused": { color: MAIN_COLOR } }}>
                                                {<Typography className={classes.typography}>{t("fleetadmins")}</Typography>}
                                                    </InputLabel>
                                                <Select
                                                    labelId="fleetadmins"
                                                    id="select"
                                                    value={fleetAdminsObj[data?.fleetadmin] || ""}
                                                    label={t("fleetadmins")}
                                                    onChange={handleChangeFleetAdmin}
                                                    className={isRTL === "rtl" ? classes.selectField_rtl : classes.selectField}
                                                >
                                                    {fleetAdmins
                                                        ? fleetAdmins.map((e) => (
                                                            <MenuItem style={{ direction: isRTL === "rtl" ? "rtl" : "ltr" }} key={e.id} value={fleetAdminsObj[e.id]}>
                                                                {<Typography className={classes.typography}>{e.desc}</Typography>}
                                                            </MenuItem>
                                                        ))
                                                        : null}
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                    ) : null}
                                </>

                                : null}

                            <Grid item xs={12} sm={12} md={12} lg={(isDriverOrFleetAdmin && !isNotAdmin) ? 6 : 12} xl={(isDriverOrFleetAdmin && !isNotAdmin) ? 6 : 12}
                                display="flex"
                                justifyContent="center"
                                alignItems="center"
                                sx={{ mt: 1 }}
                            >
                                <Button
                                    onClick={id ? handleUpdate : handleAdd}
                                    variant="contained"
                                    sx={{
                                        borderRadius: "999px",
                                        minHeight: 50,
                                        px: 4,
                                        width: (((isDriverOrFleetAdmin && !isNotAdmin) || isMidScreen) ? "100%" : "50%"),
                                        background: `linear-gradient(90deg, ${C2.violet} 0%, ${C2.bright} 100%)`,
                                        boxShadow: "0 8px 20px rgba(100,17,237,0.28)",
                                        textTransform: "none",
                                        "&:hover": {
                                            background: `linear-gradient(90deg, ${C2.deep} 0%, ${C2.violet} 100%)`,
                                        },
                                    }}
                                >
                                    <Typography
                                        sx={{
                                            color: C2.white,
                                            textAlign: "center",
                                            fontSize: 16,
                                            fontFamily: C2_FONT,
                                            fontWeight: 700,
                                        }}
                                    >
                                        { id ? t("update") : t("add")}
                                    </Typography>
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                </Box>
            </Card>
            <AlertDialog open={commonAlert.open} onClose={handleCommonAlertClose}>
                {commonAlert.msg}
            </AlertDialog>
        </Box>
    );
}

export default EditUser